import { AnyHash, NameableInterface, nString, uNumber, Uuid } from '@hidat/huijs-common';
import { ZonedDateTime } from '@js-joda/core';
import { SplixerNestResourceInterface } from './splixer-resource.interface';
import {
  BrandedResource,
  ExtendedBrandingInterface,
} from './branded-resource.interface';
import { ResourceConfig } from '@hidat/huijs-resource';
import { SplixerResourceTypes } from './splixer-resource-types';

/**
 * A very simple content post that can have a url, mix, or segment attached to it.
 */

export const PostConfig = new ResourceConfig(SplixerResourceTypes.Post)

export interface PostInterface
  extends
    SplixerNestResourceInterface,
    NameableInterface,
    BrandedResource<Uuid> {
  id: Uuid | undefined;

  name: string | undefined;
  description: string | undefined;
  tagLine: string | undefined;
  steerableTagLine: nString;
  imageUrl: string | undefined;
  branding: ExtendedBrandingInterface | undefined;
  programId: number | undefined;
  hostId: number | undefined;
  urlStub: nString;

  // Associated Media/Content
  mixId: number | undefined;
  segmentId: number | undefined;
  externalContentUrl: nString;
  externalMediaUrl: AnyHash | undefined;

  // Availability
  featured: boolean | undefined;
  priority: uNumber;
  startsAt: ZonedDateTime | undefined | null;
  endsAt: ZonedDateTime | undefined | null;

  tenantId: Uuid | undefined;
  stationId: number | undefined;
}
